import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id 868506A4-50DB-4C9C-9CEA-278969298EF4
 * name format-letter-spacing
 * version: 6.4.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/format-letter-spacing.svg
 * tags
 * - Text / Content / Format 
 */
export const FormatLetterSpacingIcon = createSvgIcon(<><path d="M14.4 10.7H18.5L16.5 5.3L14.4 10.7M15.6 3H17.3L22 15H20.1L19.1 12.4H13.7L12.7 15H10.8L15.6 3M11.2 3H13.1L8.4 15H6.7L2 3H3.9L7.5 12.7M19 22V20H5V22L2 19L5 16V18H19V16L22 19L19 22Z" /></>, 'FormatLetterSpacingIcon');
export default FormatLetterSpacingIcon